import { render, staticRenderFns } from "./Taekwondo.vue?vue&type=template&id=30b36fa6&"
import script from "./Taekwondo.vue?vue&type=script&lang=js&"
export * from "./Taekwondo.vue?vue&type=script&lang=js&"
import style0 from "./Taekwondo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports